import { render, staticRenderFns } from "./centilliongod.vue?vue&type=template&id=2eb433c0&scoped=true"
import script from "./centilliongod.vue?vue&type=script&lang=js"
export * from "./centilliongod.vue?vue&type=script&lang=js"
import style0 from "./centilliongod.vue?vue&type=style&index=0&id=2eb433c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb433c0",
  null
  
)

export default component.exports